// Copyright 2022 - 2023 Fewcha. All rights reserved.

import { useAppSelector } from "app/hooks";
import { selectConfig } from "features/config/configReducer";
import React from "react";
import cn from "services/cn";

const Benefits: React.FC = () => {
  const config = useAppSelector(selectConfig);

  return (
    <section className="pt-7 pb-20 max-w-[1232px] mx-auto w-full px-6 xl:px-0 text-white mt-[157px]" id="benefit">
      <h3 className="text-[36px]">Membership Perks</h3>
      <table className="table w-full mt-9">
        <thead>
          <tr>
            {["Benefits", "Tier 1", "Tier 2", "Tier 3", "Tier 4", "Tier 5", "Tier 6"].map((level, index) => (
              <th
                className={cn("py-5", {
                  "pl-2 w-[25%] md:w-[40%] text-sm md:text-[16px] text-left": index === 0,
                })}
                key={level}
              >
                {level}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="tbody">
          {config.benefits.map((benefit) => (
            <tr key={benefit.label}>
              <td className="pl-2 text-[14px] md:text-[16px]">{benefit.label}</td>
              {Array.from("123456").map((item, index) => (
                <td key={index} className="text-center">
                  {benefit.countLevel.includes(item) ? <span>Yes</span> : ""}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
};

export default Benefits;
